export const numberWithComma = (val: number) =>
  val.toLocaleString('ko-KR', { maximumSignificantDigits: 10 });

export const numberToK = (val: number) => (val >= 1000 ? `${(val / 1000).toFixed(1)}K` : val);
